import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EmployeeInjuryIllnessSubmit, EmployeeInjuryIllnessVerbose } from '../models/employee-injury-illness.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeInjuryIllnessService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getInjuryIllnesses(employeeId: string, take?: number, skip?: number, sort?: string, filter?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.INJURY_ILLNESS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteInjuryIllness(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.INJURY_ILLNESS}/${id}`, {
      headers: headers
    });
  }

  getInjuryIllness(employeeId: string, id: string): Observable<EmployeeInjuryIllnessVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.INJURY_ILLNESS}/${id}`, {
      headers: headers
    });
  }

  updateInjuryIllness(employeeId: string, employeeInjuryIllness: EmployeeInjuryIllnessSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.INJURY_ILLNESS}/${employeeInjuryIllness.id}`, employeeInjuryIllness, {
      headers: headers
    });
  }

  createInjuryIllness(employeeId: string, employeeInjuryIllness: EmployeeInjuryIllnessSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.INJURY_ILLNESS}`, employeeInjuryIllness, {
      headers: headers
    });
  }
}

